import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-white" data-id="element-58">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
        <div className="mb-16 text-center max-w-2xl mx-auto" data-id="element-60">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-4" data-id="element-61">
            <div className="h-[1px] w-8 bg-border" data-id="element-62" />
            <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-63">
              Get In Touch
            </span>
            <div className="h-[1px] w-8 bg-border" data-id="element-64" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-65">
            Contact Us
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-66">
          <div className="bg-warm-grey rounded-xl p-8 md:p-10 border border-border shadow-sm" data-id="element-67">
            <h3 className="text-xl font-bold text-charcoal mb-6" data-id="element-68">
              Contact Information
            </h3>

            <div className="space-y-6" data-id="element-69">
              <div data-id="element-70">
                <p className="text-sm font-bold text-charcoal uppercase tracking-wider mb-1" data-id="element-71">
                  Business Development
                </p>
                <p className="text-body font-medium" data-id="element-72">Dencell Green</p>
              </div>

              <div className="flex items-start gap-4" data-id="element-73">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shrink-0" data-id="element-74">
                  <MailIcon className="w-5 h-5 text-primary" data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <p className="text-sm font-medium text-charcoal mb-1" data-id="element-77">
                    Email
                  </p>
                  <a href="mailto:dencell.green@kingsburymc.com" className="text-body hover:text-primary transition-colors" data-id="element-78">
                    dencell.green@kingsburymc.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-79">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shrink-0" data-id="element-80">
                  <PhoneIcon className="w-5 h-5 text-primary" data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <p className="text-sm font-medium text-charcoal mb-1" data-id="element-83">
                    Phone
                  </p>
                  <a href="tel:4162089236" className="text-body hover:text-primary transition-colors" data-id="element-84">
                    416 208 9236
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-85">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shrink-0" data-id="element-86">
                  <MapPinIcon className="w-5 h-5 text-primary" data-id="element-87" />
                </div>
                <div data-id="element-88">
                  <p className="text-sm font-medium text-charcoal mb-1" data-id="element-89">
                    Address
                  </p>
                  <address className="text-body not-italic" data-id="element-90">
                    1-81 Milliken Blvd
                    <br data-id="element-91" />
                    Scarborough, ON M1V 1V3
                  </address>
                </div>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="w-full h-48 bg-warm-grey rounded-xl border border-border overflow-hidden relative" data-id="element-92">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80')] bg-cover bg-center opacity-40 grayscale" data-id="element-93" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-94">
              <div className="bg-white px-4 py-2 rounded-md shadow-md flex items-center gap-2" data-id="element-95">
                <MapPinIcon className="w-4 h-4 text-primary" data-id="element-96" />
                <span className="text-sm font-medium text-charcoal" data-id="element-97">
                  Scarborough, Ontario
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}